export default __webpack_public_path__ + "static/media/vBankSmallLogoWhite.cdd8e32e.svg";